import { AnnouncementListResponse } from "../models/response/announcementRetrieveResponse";
import { UserProfileResponse } from "../models/response/userProfileResponse";
import { UserProfileUpdateRequest } from "../models/request/userProfileUpdateRequest";
import userApi from "../api/user.api";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { UserPendingDataResponse } from "../models/response/userPendingDataResponse";
import errorModal from "../../../services/errorModal.service";
import { UpdateUserBiometricsRequest } from "../models/request/updateUserBiometricsRequest";
import { DocumentUploadRequest } from "../models/request/documentUploadRequest";

const userService = {
  getUserProfile: async (): Promise<UnifiedResponse<UserProfileResponse>> => {
    var response = await userApi.getUserProfile();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  updateUserProfile: async (
    data: UserProfileUpdateRequest,
  ): Promise<UnifiedResponse<UserProfileResponse>> => {
    return await userApi.updateUserProfile(data);
  },

  updateUserLanguage: async (
    languageCode: string,
  ): Promise<UnifiedResponse<any>> => {
    return await userApi.updateUserLanguage(languageCode);
  },

  sendEmailVerificationCodeOld: async (): Promise<UnifiedResponse<any>> => {
    return await userApi.sendEmailVerificationCodeOld();
  },

  verifyEmailVerificationCodeOld: async (
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    return await userApi.verifyEmailVerificationCodeOld(code);
  },

  sendEmailVerificationCode: async (
    userId: string,
    email: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await userApi.sendEmailVerificationCode(userId, email);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },

  verifyEmailVerificationCode: async (
    userId: string,
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await userApi.verifyEmailVerificationCode(userId, code);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },

  sendMobileVerificationCodeOld: async (): Promise<UnifiedResponse<any>> => {
    return await userApi.sendMobileVerificationCodeOld();
  },

  verfiyMobileVerificationCodeOld: async (
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    return await userApi.verfiyMobileVerificationCodeOld(code);
  },

  sendMobileVerificationCode: async (
    userId: string,
    mobile: string,
    countryCode: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await userApi.sendMobileVerificationCode(
      userId,
      mobile,
      countryCode,
    );

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  verfiyMobileVerificationCode: async (
    userId: string,
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await userApi.verfiyMobileVerificationCode(userId, code);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },

  updateUserSecondLoginData: async (
    userId: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await userApi.updateUserSecondLoginData(userId);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },

  resetPassword: async (
    password: string,
    confirmPassword: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await userApi.resetPassword(password, confirmPassword);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },

  fetchUserPendingData: async (): Promise<UnifiedResponse<UserPendingDataResponse>> => {
    return await userApi.fetchUserPendingData();
  },

  retrieveAnnouncements: async (data: {
    LanguageCode: string;
  }): Promise<UnifiedResponse<AnnouncementListResponse>> => {
    return await userApi.retrieveAnnouncements(data);
  },

  updateUserBiometrics: async (
    data: UpdateUserBiometricsRequest,
  ): Promise<UnifiedResponse<any>> => {
    return await userApi.updateUserBiometrics(data);
  },

  uploadUserAvatar: async (
    data: DocumentUploadRequest,
  ): Promise<UnifiedResponse<any>> => {
    return await userApi.uploadUserAvatar(data);
  },
};

export default userService;
